import { getBody } from './getBody.js';
import { setFakeBody } from './setFakeBody.js';
import { resetFakeBody } from './resetFakeBody.js';

export function mediaquerySupport() {
  var doc = document,
    body = getBody(),
    docOverflow = setFakeBody(body),
    div = doc.createElement('div'),
    style = doc.createElement('style'),
    rule = '@media all and (min-width:1px){.tns-mq-test{position:absolute}}',
    position;

  style.type = 'text/css';
  div.className = 'tns-mq-test';

  body.appendChild(style);
  body.appendChild(div);

  if (style.styleSheet) {
    style.styleSheet.cssText = rule;
  } else {
    style.appendChild(doc.createTextNode(rule));
  }

  position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle['position'];

  body.fake ? resetFakeBody(body, docOverflow) : div.remove();

  return position === 'absolute';
}
